export default __webpack_public_path__ + "static/media/05.7baaf35c.webp";